import { code } from "@spscommerce/utils";

export const SpsSpinnerExamples = {
    basic: {
        examples: {
            small: {
                template: code`
                    <sps-spinner size="small">Default</sps-spinner>
                `
            },
            medium: {
                template: code`
                    <sps-spinner size="medium">Default</sps-spinner>
                `
            },
            large: {
                template: code`
                    <sps-spinner size="large">Default</sps-spinner>
                `
            }
        },
    }
};
